module.exports = __webpack_public_path__ + "img/farmer.9c0694cf.svg";